import { useSelector } from 'react-redux';

export const useVariationId = (campaignId, variationId): any => {
  return useSelector((s: any) => {
    const isVariation = !!(s?.tests || []).find(
      (t) => t.campaignId === parseInt(campaignId) && t.variationId === parseInt(variationId || 0)
    );
    const isControl = !variationId && !(s?.tests || []).find((t) => t.campaignId === parseInt(campaignId));

    return isControl || isVariation;
  });
};

export default useVariationId;
